import React, { Ref, forwardRef } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { useLinkTo } from '@react-navigation/native';

import { common } from '@/styles/styles';
import { isWeb } from '@/utils/constants-platform-specific';
import { handleWebviewMessage } from '@/utils/webview';

import { LoadingSpinner } from './LoadingSpinner';
import WebView, { WebViewMessageEvent, WebViewNavigation, WebViewProps } from './Webview';

interface Props extends WebViewProps {
    uri: string;
    onNavigationStateChange?: (event: WebViewNavigation) => void;
    openNewTabOnWeb?: boolean;
    styles?: StyleProp<ViewStyle>;
    loaderStyles?: StyleProp<ViewStyle>;
}

const CustomWebView = forwardRef((props: Props, ref?: Ref<WebView>) => {
    const {
        uri,
        onNavigationStateChange,
        openNewTabOnWeb = false,
        styles = {},
        loaderStyles = {},
        ...webViewProps
    } = props;
    const linkTo = useLinkTo();

    return (
        <WebView
            {...webViewProps}
            source={{ uri }}
            originWhitelist={['*']}
            startInLoadingState={true}
            style={[common.backgroundColorTransparent, styles]}
            renderLoading={() => (
                <View style={[common.alignCenter, common.justifyCenter, common.fullHeight, loaderStyles]}>
                    <LoadingSpinner />
                </View>
            )}
            onMessage={(event: WebViewMessageEvent) => handleWebviewMessage(event?.nativeEvent, linkTo)}
            onNavigationStateChange={onNavigationStateChange}
            ref={isWeb ? undefined : ref}
            // this is used for Webview.web.tsx but not recognized by WebView type from mobile
            // @ts-ignore
            openNewTabOnWeb={openNewTabOnWeb}
        />
    );
});

export default CustomWebView;
